
export const REQUEST_GETVIDEONOTE= 'REQUEST_GETVIDEONOTE';
export const GETVIDEONOTE_RECEIVED = 'GETVIDEONOTE_RECEIVED';